import { FeConstants } from 'constants/FeConstants';
import { generateCodeChallenge, generateCodeVerifier } from 'utils/pkce';

export const SALESFORCE_CODE_VERIFIER_KEY = 'salesforce_pkce_code_verifier';

/**
 * Starts a PKCE-enabled Salesforce OAuth flow: generates a fresh
 * `code_verifier`, stores it in sessionStorage for the callback, and returns
 * the authorization URL with the derived `code_challenge` (S256) appended.
 */
export const buildSalesforceLoginUrl = async (): Promise<string> => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  sessionStorage.setItem(SALESFORCE_CODE_VERIFIER_KEY, codeVerifier);
  return `${FeConstants.SALESFORCE_LOGIN_URL}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
};

export const readSalesforceCodeVerifier = (): string | null =>
  sessionStorage.getItem(SALESFORCE_CODE_VERIFIER_KEY);

export const clearSalesforceCodeVerifier = (): void =>
  sessionStorage.removeItem(SALESFORCE_CODE_VERIFIER_KEY);
